import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Typography, useTheme } from '@mui/material';
import React from 'react';
import { AppPageHeader } from '../AppPageHeader';
import { useCommonWebTranslation } from '../hooks';
/**
 * @deprecated Replaced by `GlobalApp`. To control scrolling behavior, use `FullHeightPage`.
 * Do not use together with `GlobalApp` in new code.
 * @param {AppPageHeader1Props} props - Props including title and optional creation button.
 * @returns {React.ReactElement} The rendered legacy page header with a title and optional "New" button.
 */
export const AppPageHeader1 = (props) => {
    const theme = useTheme();
    const { t } = useCommonWebTranslation();
    return (React.createElement(AppPageHeader, null,
        React.createElement(Typography, { sx: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                marginRight: props.onCreate ? theme.spacing(2) : 0,
            }, variant: 'h5', "data-test": 'app-page-header1-title' }, props.title),
        props.onCreate && (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: { flexShrink: 0 } },
                React.createElement(Button, { variant: 'contained', color: 'primary', "data-test": 'app-page-header1-new-button', startIcon: React.createElement(AddIcon, null), onClick: props.onCreate }, props.createButtonText || t('common.new')))))));
};
